import { transformFormProductToCartItem } from '@/features/pos/components/Cart/utils/transforms'
import { useEditCartItemActions } from '@/features/pos/components/OrderFinalization/contexts/EditCartItemProvider'
import { useUpdateCartItem } from '@/features/pos/components/OrderFinalization/hooks/useUpdateCartItem'
import { Form } from '@/features/pos/components/ProductConfigurationModal/form/types'
import { useCallback } from 'react'
import invariant from 'tiny-invariant'

export const useConfirmProductConfiguration = (
    cartItemId: string | undefined
): ((form: Form) => Promise<void>) => {
    const { unset } = useEditCartItemActions()

    const updateCartItem = useUpdateCartItem()

    return useCallback(
        async (form: Form) => {
            invariant(cartItemId, 'cartItemId must be set')

            await updateCartItem(transformFormProductToCartItem(form, cartItemId))

            unset()
        },
        [cartItemId, updateCartItem, unset]
    )
}
